import { useCallback, useEffect } from 'react';
import useInitialRender from '../browser/useInitialRender';
import useABFeaturesFromLocalStorage from './useABFeaturesFromLocalStorage';
import { isBrowser } from '@/helpers/browser';

const useABFeatureFromLocalStorage = ({ featureKey } = {}) => {
  const { isFirstRender } = useInitialRender();
  const {
    features,
    initialiseFeature,
    updateFeatureEnabledStatus,
    trackFeatureStatusInGA
  } = useABFeaturesFromLocalStorage();

  const feature = features[featureKey];
  const {
    initialised, enabled, ...customProperties
  } = feature || {};

  useEffect(() => {
    if (isBrowser()) {
      initialiseFeature({ featureKey });
    }
  }, [featureKey, initialiseFeature]);

  useEffect(() => trackFeatureStatusInGA({
    featureKey,
    isEnabled: enabled
  }), [trackFeatureStatusInGA, enabled, featureKey]);

  const setFeatureEnabledStatus = useCallback((shouldEnable = false) => updateFeatureEnabledStatus({
    featureKey,
    shouldEnable
  }), [featureKey, updateFeatureEnabledStatus]);

  return {
    isEnabled: initialised && !isFirstRender && enabled,
    isLoading: isFirstRender || !initialised,
    ...customProperties,
    setFeatureEnabledStatus
  };
};

export default useABFeatureFromLocalStorage;